import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../contexts/UserContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import {BsArrowBarDown,BsArrowBarUp} from "react-icons/bs"
import displayError from '../../utils/ErrorHandler';
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { setActiveZoneId, getActiveZoneId } from '../../utils/zoneSession';
import { isAdminRole } from '../../utils/roles';
import { n2 } from '../../utils/fmt';


const Stock = () => {
  const { user,setUser } = useContext(UserContext);
  const [stock, setStock] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [message,setMessage] = useState('')
  const navigate = useNavigate();

  const getStock = async () => {
    console.log("IN GETTING ZONES");
    console.log(user);
    const zoneId = user?.zone?._id || getActiveZoneId();
    if(user?.zone?._id) setActiveZoneId(user.zone._id);
    if (isAdminRole(user?.role)) {
      if(!zoneId) return; // cannot fetch until known
      await axios.get(`${process.env.REACT_APP_API_URI}/api/stock/get?id=${zoneId}`, { withCredentials: true })
      .then((response) => {
        console.log(response?.data?.data);
        if (response.data.success) {
          setStock(response?.data?.data);
        }
      })
      .catch((err) => {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setMessage(errorMessage)
          }
      })
     } else {
        // For non-admin users, include the zone id if available so backend can load tenant stock
        if(!zoneId) return; // can't fetch until zone is known
        await axios.get(`${process.env.REACT_APP_API_URI}/api/stock/get?id=${zoneId}`, { withCredentials: true }).then((response) => {
          console.log(response?.data?.data);
          if (response.data.success) {
            setStock(response?.data?.data);
          }
        })
        .catch((err) => {
          const errorMessage = displayError(err,navigate,setUser);
          console.log(errorMessage);
            if(errorMessage){
              setMessage(errorMessage)
            }
        })
     }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredStock = stock.filter((item) =>
    item.item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleItemIn = () => {
    navigate("/zc/item-in");
    console.log("Item-in button clicked");
  };

  const handleItemOut = () => {
    navigate("/zc/item-out");
    console.log("Item-out button clicked");
  };

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
      if(user?.zone?._id){
        setActiveZoneId(user.zone._id);
      }
      if(user || getActiveZoneId()){
        getStock();
      }
    }
    startup();
  },[user])

  const handleExportToExcel = () => {
  if (!stock || stock.length === 0) return;

  // Get zone name from first item (assuming all are from same zone)
  const zoneName = stock[0]?.zone?.desc || "Unknown Zone";

  // Create worksheet data
  const wsData = [];

  // Add the zone header row (merged across 2 columns)
  wsData.push([`Stock Inventory for Zone: ${zoneName}`]);
  wsData.push([]); // blank row

  // Add column headers
  wsData.push(["Item Name", "Quantity Present"]);

  // Add item rows
  stock.forEach((item) => {
    wsData.push([
      item.item.name,
      `${n2(item.quantity)} ${item.item.unit}`,
    ]);
  });

  // Create sheet and apply merge
  const ws = XLSX.utils.aoa_to_sheet(wsData);
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // Merge zone title row
  ];

  // Adjust column widths
  ws["!cols"] = [{ wch: 30 }, { wch: 20 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Stock");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `Stock_Inventory_${zoneName}.xlsx`);
};

  return (
    <>
    <div className="bg-lime-800 flex items-center justify-between w-full p-4 text-white fixed z-10">
  <h4 className="text-lg md:text-xl font-semibold text-center flex-grow text-center">Items Stock</h4>

  <div className="flex items-center space-x-2 ml-auto">
  {((isAdminRole(user?.role) && stock[0]?.zone?.desc==='central zone') || user?.zone?.desc?.toLowerCase() === 'central zone') && (


    <button
      onClick={() => navigate("/zc/create-items-request")}
      className="bg-white text-lime-800 text-sm font-semibold px-3 py-1 rounded"
    >
      Add Item to Stock
    </button>
  )}

    {((isAdminRole(user?.role) && stock[0]?.zone?.desc==='central zone') || user?.zone?.desc?.toLowerCase() === 'central zone') && (
    
      
      <button
        onClick={() => navigate('/central/requests')}
        className="bg-white text-lime-800 text-sm font-semibold px-3 py-1 rounded"
      >
        View Send to Zone
      </button>
    )}
    {((isAdminRole(user?.role) && stock[0]?.zone?.desc==='central zone') || user?.zone?.desc?.toLowerCase() === 'central zone') && (
    
      
    <button
      onClick={() => navigate('/central/send-to-zone')}
      className="bg-white text-lime-800 text-sm font-semibold px-3 py-1 rounded"
    >
      Send to Zone
    </button>
  )}
    <button
      onClick={handleExportToExcel}
      className="bg-white text-lime-800 text-sm font-semibold px-3 py-1 rounded"
    >
      Export To Excel
    </button>
  </div>
</div>

    {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
    <div className="p-4 pt-[70px] ">
      <div className="relative mb-4">
        <input
          type="text"
          placeholder="Search"
          className="w-full p-2 border border-gray-300 rounded"
          value={searchTerm}
          onChange={handleSearch}
        />
      </div>
      {stock.length === 0 ? (
        <div className="text-center mt-10">
          <h6 className="text-gray-600">No Inventory In Zone! Order some!</h6>
        </div>
      ) : (
        <ul>
          {filteredStock.map((item, index) => (
            <React.Fragment key={item._id}>
              <li className="py-1">
                <div className="flex justify-between">
                  <div>
                    <h2 className="text-[15px] text-fmb font-semibold">{item.item.name}</h2>
                    <p className="text-xs text-gray-500">{item.item.category}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">In Stock</p>
                    <p className="text-[15px] font-semibold">{parseFloat(item.quantity).toFixed(2)} {item.item.unit}</p>
                  </div>
                </div>
              </li>
              {index < filteredStock.length - 1 && <hr className="my-2 border-gray-300" />}
            </React.Fragment>
          ))}
        </ul>
      )}
      <div className="flex w-full justify-around align-super items-center mb-4 fixed bottom-16">
        <button 
          onClick={handleItemIn} 
          className="bg-fmb-light text-white text-sm px-4 py-2 rounded-lg mr-2 shadow-md"
        >
        <div className='flex flex-row space-x-2 items-center'>
          <BsArrowBarDown/>
            <span>Item-In </span>
          </div>
        </button>
        <button 
          onClick={handleItemOut} 
          className="bg-fmb-light text-white text-sm px-4 py-2 rounded-lg mr-7 shadow-md"
        >
          <div className='flex flex-row space-x-2'>
          <BsArrowBarUp/>
            <span>Item-Out</span>
          </div>
        </button>
      </div>
    </div>
    </>
  );
};

export default Stock;
